<template>
    <div class="attribute-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="searchText" />
            <span class="material-icons"> search </span>
        </div>
        <div class="btnGroup">
            <SupsisButton
                :classNames="selectedContext === context ? 'btnGroupItem selected' : 'btnGroupItem '"
                :primary="selectedContext === context"
                :ghost="selectedContext !== context"
                @click="() => changeSelectedContext(context)"
                small
                v-for="context in allowedContexts"
                :key="context"
            >
                {{ $_.startCase(context) }}
            </SupsisButton>
        </div>

        <GeneralAttributePicker
            :story-id="storyId"
            :default-selected="defaultSelected"
            :pick="pick"
            :filter-mode="filterMode"
            :search-text-prop="searchText"
            v-if="selectedContext === 'general'"
        />
        <TableAttributePicker :on-picked="pick" v-if="selectedContext === 'table'" />
        <APIAttributePicker :on-picked="pick" v-if="selectedContext === 'api'" />
        <WebSearchAttributePicker :on-picked="pick" v-if="selectedContext === 'websearch'" />
        <AICallAttributePicker :on-picked="pick" v-if="selectedContext === 'aicall'" />
        <RunJavaScriptAttributePicker :on-picked="pick" v-if="selectedContext === 'runjavascript'" />
        <CustomBlockAttributePicker :on-picked="pick" v-if="selectedContext === 'customblock'" />
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import systemAttributes from "../../../utils/systemAttributes";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import TableAttributePicker from "./TableAttributePicker.vue";
import APIAttributePicker from "./APIAttributePicker.vue";
import GeneralAttributePicker from "./GeneralAttributePicker.vue";
import WebSearchAttributePicker from "./WebSearchAttributePicker.vue";
import AICallAttributePicker from "./AICallAttributePicker.vue";
import RunJavaScriptAttributePicker from "./RunJavaScriptAttributePicker.vue";
import CustomBlockAttributePicker from "./CustomBlockAttributePicker.vue";

const log = log2("AttributePicker");
export default {
    name: "AttributePicker",
    components: {
        GeneralAttributePicker,
        TableAttributePicker,
        SupsisButton,
        systemAttributes,
        APIAttributePicker,
        WebSearchAttributePicker,
        AICallAttributePicker,
        RunJavaScriptAttributePicker,
        CustomBlockAttributePicker,
    },
    props: {
        defaultSelected: {
            type: String,
            required: false,
        },
        pick: {
            type: Function,
            required: true,
        },
        filterMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
        allowedContexts: {
            type: Array,
            default: () => ["general", "table", "api", "websearch", "aicall", "runjavascript", "customblock"],
        },
    },
    data() {
        return {
            searchText: "",
            storyId: this.$route.params.id,
            selectedContext: "general",
        };
    },
    methods: {
        changeSelectedContext(context) {
            this.selectedContext = context;
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$el.querySelector('input[type="text"]').focus();
        });
    },
};
</script>

<style lang="scss">
.attribute-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .attribute-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 15px;
        margin: 0px 5px 0px 5px;
        gap: 10px;

        .attr-select {
            margin-bottom: 10px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 5px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons,
        .custom-attr-logo {
            color: #647283;
            font-size: 25px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 30px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
